"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromBn = void 0;
const bignumber_1 = require("@ethersproject/bignumber");
/**
 * Convert a big number with a custom number of decimals to a stringified fixed-point number.
 */
function fromBn(x, decimals = 18) {
    if (x === undefined) {
        throw new Error("Input must not be undefined");
    }
    if (decimals < 1 || decimals > 77) {
        throw new Error("Decimals must be between 1 and 77");
    }
    const result = bignumber_1.FixedNumber.fromValue(x, decimals, `fixed256x${decimals}`).toString();
    return result.replace(/.0$/, "");
}
exports.fromBn = fromBn;
//# sourceMappingURL=fromBn.js.map